import Http from "./base-http";
class AvailabilitySchedule extends Http {
  addAvailabilitySchedule(variables) {
    return this.create(variables);
  }
  delAvailabilitySchedule(id) {
    return this.destroy(id);
  }
}

const availabilityScheduleObj = new AvailabilitySchedule({
  modelUrlPrefix : "AvailabilitySchedule"
});

export default availabilityScheduleObj;
